let anchorlinks = document.querySelectorAll('a[href^="#"]');

for (let item of anchorlinks) {
  item.addEventListener('click', (e) => {
    let hashval = item.getAttribute('href').substring(1); 
    let target = document.getElementById(hashval);
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
      history.pushState(null, null, '#' + hashval);
      e.preventDefault();
    }
  });
}